// extracted by mini-css-extract-plugin
module.exports = {"textIcon":"b3_kj","textIcon__icon":"b3_kk"};